import SearchBox from "../../common_nextgen/common_components/SearchScreenComponents/SearchBox";  
import DisplayTable from "../../common_nextgen/common_components/SearchScreenComponents/DisplayTable";  
import ButtonsSection from "../../common_nextgen/common_components/SearchScreenComponents/ButtonsSection";  
import NextGenPaginator from "../../common_nextgen/common_components/Pagination/NextGenPaginator";  
import ConfirmationModal from "../../common_nextgen/common_components/Modal/ConfirmationModal";   
import useAlternateCopayPSCOverrides from "../BenefitMaxSchedule/hooks/useAlternateCopayPSCOverrides";  
  
const AlternateCopayPSCOverrides = () => {  
  const alternateCopayPSCOverridesData = useAlternateCopayPSCOverrides();  
  
  return (  
    <div class="container container-fluid">  
     <ButtonsSection ctaButtons={alternateCopayPSCOverridesData.leftButtons} align="left" /> 
      <div className="header-section">  
        <h1>  
          {alternateCopayPSCOverridesData.screen_title} -{" "}  
          <span className="heading-cod">{alternateCopayPSCOverridesData.screenNumber}</span>  
        </h1>  
      </div>  
      <SearchBox  
        formFields={alternateCopayPSCOverridesData.formFields}  
        dropdownValues={alternateCopayPSCOverridesData.dropdownValues}  
        paramsData={alternateCopayPSCOverridesData.paramsData}  
        updataParamData={alternateCopayPSCOverridesData.updateParamData}  
      />  
      <ButtonsSection ctaButtons={alternateCopayPSCOverridesData.ctaButtons} />  
      <DisplayTable  
        data={alternateCopayPSCOverridesData.data}  
        parmKey={alternateCopayPSCOverridesData.parmKey}  
        menuOptions={alternateCopayPSCOverridesData.menuOptions}  
        tableHeaders={alternateCopayPSCOverridesData.columnDef}  
        setRowData={alternateCopayPSCOverridesData.setRowData}  
        selectedPriceSchedules={alternateCopayPSCOverridesData.selectedRows}  
        setSelectedPriceSchedules={alternateCopayPSCOverridesData.setSelectedRows}  
      />  
      <div className="paginator-container">  
        <NextGenPaginator  
          first={alternateCopayPSCOverridesData.first}  
          rows={alternateCopayPSCOverridesData.rows}  
          totalRecords={alternateCopayPSCOverridesData.totalRecords}  
          currentPage={alternateCopayPSCOverridesData.currentPage}  
          rowsPerPageOptions={[10, 25, 50]}  
          onPageChange={alternateCopayPSCOverridesData.onPageChange}  
        />  
      </div>  
      {alternateCopayPSCOverridesData.isConfirmationModalOpen && (  
        <ConfirmationModal  
          isOpen={alternateCopayPSCOverridesData.isConfirmationModalOpen}  
          onRequestClose={alternateCopayPSCOverridesData.closeConfirmationModal}  
          onBack={alternateCopayPSCOverridesData.closeConfirmationModal}  
          onSave={alternateCopayPSCOverridesData.deletePriceSchedule}  
          confirmLabel="Confirm(Y/N)"  
          options={[  
            { label: "N-No", value: "no" },  
            { label: "Y-Yes", value: "yes" },  
          ]}  
          setSelectedOption={alternateCopayPSCOverridesData.setSelectedOption}  
        />  
      )}  
    </div>  
  );  
};  
  
export default AlternateCopayPSCOverrides;